<template>
  <!-- Toggle B -->
  <div class="flex items-center justify-center">
    <label for="toggleButton" class="flex items-center cursor-pointer">
      <!-- label -->
      <div class="mr-3 text-gray-500 text-sm font-bold">{{ toggleTitle }}</div>
      <!-- toggle -->
      <div class="relative">
        <!-- input -->
        <input
          v-if="toggleCheck"
          type="checkbox"
          id="toggleButton"
          class="sr-only"
          checked
        />
        <input v-else type="checkbox" id="toggleButton" class="sr-only" />
        <!-- line -->
        <div
          class="line block bg-gray-300 w-10 h-6 rounded-full transition"
        ></div>
        <!-- dot -->
        <div
          class="
            dot
            absolute
            left-1
            top-1
            bg-white
            w-4
            h-4
            rounded-full
            transition
          "
        ></div>
      </div>
    </label>
  </div>
</template>

<style scoped>
input:checked ~ .dot {
  transform: translateX(100%);
}
input:checked ~ .line {
  background-color: #48bb78;
}
</style>

<script>
export default {
  props: {
    toggleTitle: String,
    toggleCheck: Boolean,
  },
};
</script>
